export default "__VITE_ASSET__Cp1flddY__"